<ul class="nav nav-underline">
  <li class="nav-item">
    <a
      class="nav-link"
      [class.active]="activeTab === 'Entrenamiento'"
      (click)="setActiveTab('Entrenamiento')"
      >Entrenamiento</a
    >
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      [class.active]="activeTab === 'Sensaciones'"
      (click)="setActiveTab('Sensaciones')"
      >Sensaciones</a
    >
  </li>
</ul>

<div class="tab-content mt-3">
  <div
    class="tab-pane fade"
    [class.show]="activeTab === 'Entrenamiento'"
    [class.active]="activeTab === 'Entrenamiento'"
  >
    <div class="">
      <div class="d-flex w-100 align-items-center justify-content-center"></div>

      <div class="mb-3 d-flex">
        <div class="d-flex text-center">
          <span class="title">Rutina de &nbsp;</span>
          <span class="title fw-bold" *ngIf="workout"
            >{{ workout.name }} -
          </span>
          <span class="title">{{
            workout.startedAt | date : "medium" : undefined : "es-ES"
          }}</span>
        </div>
      </div>

      <div class="offset-3 col-6 align-self-center" *ngIf="workout">
        <div
          class="exercise"
          *ngFor="let exerciseGroup of exercisesByExerciseGroup"
        >
          <div
            class="set-type d-flex justify-content-center align-items-center m-2"
            *ngIf="exerciseGroup.length > 1"
          >
            <span class="set-text d-flex" *ngIf="exerciseGroup.length == 2"
              >Superserie</span
            >
            <span class="set-text" *ngIf="exerciseGroup.length == 3"
              >Triserie</span
            >
            <span class="set-text" *ngIf="exerciseGroup.length > 3"
              >Serie Gigante</span
            >
          </div>
          <div class="" *ngFor="let exercise of exerciseGroup">
            <span class="exercise-title">{{ exercise.exercise!.name }}</span>
            <div class="d-flex">
              <i class="bi bi-caret-right-fill exercise-icon me-2"></i>
              <span class="exercise-reps">{{ exercise.summary }}</span>
            </div>

            <div class="d-flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#fed533"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-weight me-2"
              >
                <circle cx="12" cy="5" r="3" />
                <path
                  d="M6.5 8a2 2 0 0 0-1.905 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.925-2.54L19.4 9.5A2 2 0 0 0 17.48 8Z"
                />
              </svg>
              <span class="exercise-reps">{{ exercise.weightText }}</span>
            </div>

            <div class="d-flex">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#fed533"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-hash me-2"
              >
                <line x1="4" x2="20" y1="9" y2="9" />
                <line x1="4" x2="20" y1="15" y2="15" />
                <line x1="10" x2="8" y1="3" y2="21" />
                <line x1="16" x2="14" y1="3" y2="21" />
              </svg>
              <span class="exercise-reps">{{ exercise.repCount }}</span>
            </div>

            <div class="d-flex">
              <span
                *ngFor="let ip of exercise.intensityPrinciples"
                class="intensity-principle"
                >{{ ip }}</span
              >
            </div>

            <div class="notes my-2" *ngIf="exercise.notes">
              <span class="notes-title">Notas del alumno</span>
              <div class="note" *ngFor="let note of exercise.notes">
                <span class="note-date">{{
                  note.createdAt | date : "dd/MM/yyyy"
                }}</span>
                <span class="note-text">{{ note.note }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="tab-pane fade"
    [class.show]="activeTab === 'Sensaciones'"
    [class.active]="activeTab === 'Sensaciones'"
  >
    <app-single-forms-answers
      [workoutData]="workout"
    ></app-single-forms-answers>
  </div>
</div>
